import { customerApi } from "../../utils/apiConfig";

const uploadExcel = (endpoint, file, fields = {}) => {
  const formData = new FormData();
  formData.append("excel", file);

  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return customerApi.post(endpoint, formData, {
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token")}`,
    },
  });
};

export const analyzeProductionSalesSummary = (file) =>
  uploadExcel("/planning/production-sales-summary/analyze", file);

export const sendProductionSalesSummary = (file, recipientEmail) =>
  uploadExcel("/planning/production-sales-summary/send", file, {
    recipientEmail,
  });
